import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/faqSection.tsx");
